// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, type NavigateOptions } from 'react-router-dom'
import { AppDispatch } from '../@types/store'
import { RootState } from '../redux/reducers/root'
import { preserveSearchParams } from '../utils/navigation'
import { useCallback } from 'react'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const useAppSelectorWithSelected = <Selected>(
  selector: (state: RootState) => Selected,
  equalityFn?: (left: Selected, right: Selected) => boolean
) => useSelector<RootState, Selected>(selector, equalityFn)

export function usePreserveSearchParamsNavigate() {
  const navigate = useNavigate()
  const location = useLocation()

  return useCallback(
    (path: string, options?: NavigateOptions) => {
      navigate(preserveSearchParams(path, location.search), options)
    },
    [navigate, location.search]
  )
}
